import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Active Status History")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Choose Date")
], -1)
const _hoisted_10 = { class: "col-md-3 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Active Status History")
  ])
], -1)
const _hoisted_19 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_20 = { class: "collapse show" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "table-responsive sticky mt-3" }
const _hoisted_23 = { class: "row w-100 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_25 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_33 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Certification"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Job Placement")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, "% on Certified")
  ])
], -1)
const _hoisted_35 = { style: {} }
const _hoisted_36 = { class: "fw-bolder bg-light" }
const _hoisted_37 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "8",
  class: "align-middle border border-gray-400"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "border border-gray-400 text-center" }
const _hoisted_48 = { colspan: "2" }
const _hoisted_49 = { class: "font-weight-bold" }
const _hoisted_50 = { class: "font-weight-bold" }
const _hoisted_51 = { class: "font-weight-bold" }
const _hoisted_52 = { class: "font-weight-bold" }
const _hoisted_53 = { class: "font-weight-bold" }
const _hoisted_54 = { class: "font-weight-bold" }
const _hoisted_55 = {
  key: 0,
  class: "fw-bolder bg-light"
}
const _hoisted_56 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "8"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_61 = ["href"]
const _hoisted_62 = {
  key: 1,
  class: "fw-bolder border border-gray-400 text-center"
}
const _hoisted_63 = { colspan: "2" }
const _hoisted_64 = { class: "font-weight-bold" }
const _hoisted_65 = { class: "font-weight-bold" }
const _hoisted_66 = { class: "font-weight-bold" }
const _hoisted_67 = { class: "font-weight-bold" }
const _hoisted_68 = { class: "font-weight-bold" }
const _hoisted_69 = { class: "font-weight-bold" }
const _hoisted_70 = {
  key: 2,
  class: "fw-bolder border border-gray-400 text-center"
}
const _hoisted_71 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { class: "font-weight-bold" }
const _hoisted_76 = { class: "font-weight-bold" }
const _hoisted_77 = { class: "font-weight-bold" }
const _hoisted_78 = { class: "font-weight-bold" }
const _hoisted_79 = { class: "font-weight-bold" }
const _hoisted_80 = { class: "font-weight-bold" }
const _hoisted_81 = {
  key: 3,
  class: "fw-bolder border border-gray-400 text-center"
}
const _hoisted_82 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { class: "font-weight-bold" }
const _hoisted_86 = { class: "font-weight-bold" }
const _hoisted_87 = { class: "font-weight-bold" }
const _hoisted_88 = { class: "font-weight-bold" }
const _hoisted_89 = { class: "font-weight-bold" }
const _hoisted_90 = { class: "font-weight-bold" }
const _hoisted_91 = { class: "fw-bolder border border-gray-400 text-center" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Grand Total (All Tranches) ")
], -1)
const _hoisted_93 = { class: "font-weight-bold" }
const _hoisted_94 = { class: "font-weight-bold" }
const _hoisted_95 = { class: "font-weight-bold" }
const _hoisted_96 = { class: "font-weight-bold" }
const _hoisted_97 = { class: "font-weight-bold" }
const _hoisted_98 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.training_date,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.training_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeStatusHistory())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_11
                    ])
                  ])
                ]),
                (_ctx.showTrainningStatistics == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                (_ctx.showTrainningStatistics == true)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                        title: "Download Xlse",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportTrainee()))
                                      }, _hoisted_27),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Download PDF",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadPdf()))
                                      }, _hoisted_29),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Print",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printPdf()))
                                      }, _hoisted_31),
                                      _hoisted_32
                                    ])
                                  ]),
                                  _createElementVNode("table", _hoisted_33, [
                                    _hoisted_34,
                                    _createElementVNode("tbody", _hoisted_35, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tmsdashboardInfo, (info, key) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                          _createElementVNode("tr", _hoisted_36, [
                                            _createElementVNode("td", _hoisted_37, [
                                              (
                                        info?.trancheInfo?.id !=
                                        info?.trancheInfo?.parent_tranche_id
                                      )
                                                ? (_openBlock(), _createElementBlock("b", _hoisted_38, [
                                                    (info?.trancheInfo?.id == 3)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "C. "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 4)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, "F. "))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(info?.trancheInfo?.label), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("b", _hoisted_41, [
                                                    (info?.trancheInfo?.id == 5)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "G. "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 2)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "D. "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 1)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, "A. "))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(info?.trancheInfo?.label), 1)
                                                  ]))
                                            ])
                                          ]),
                                          _hoisted_45,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.job_place_entity, (data, inx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: inx,
                                              class: "border border-gray-400 text-center"
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("a", {
                                                  href: `${this.VUE_APP_TMS}/course-summary/2/` +
                                          info?.trancheInfo?.id +
                                          '/' + data?.id
                                        ,
                                                  target: "_blank",
                                                  class: "text-black fw-bold fs-6 mt-2"
                                                }, _toDisplayString(data?.entity_short_name), 9, _hoisted_46)
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data?.femaleEnrollment).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.percentage_of_job_placement
                                          ? (data?.percentage_of_job_placement).toFixed(2)
                                          : 0), 1)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("tr", _hoisted_47, [
                                            _createElementVNode("td", _hoisted_48, [
                                              _createElementVNode("b", null, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ")", 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_49, _toDisplayString(Number(info?.trancheInfo?.subTotalTrainee).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_50, _toDisplayString(Number(
                                          info?.trancheInfo?.subTotalEnrollment
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_51, _toDisplayString(Number(
                                          info?.trancheInfo?.subTotalfemaleEnrollment
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_52, _toDisplayString(Number(
                                          info?.trancheInfo?.subTotalCertification
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_53, _toDisplayString(Number(
                                          info?.trancheInfo?.subTotalJobPlacement
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_54, _toDisplayString((info?.trancheInfo?.subTotalPercentageOfJobPlacement).toFixed(
                                          2
                                        )), 1)
                                          ]),
                                          (
                                    info?.trancheInfo?.id ==
                                    info?.trancheInfo?.parent_tranche_id
                                  )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                                                _createElementVNode("td", _hoisted_56, [
                                                  _createElementVNode("b", null, [
                                                    (info?.trancheInfo?.id == 5)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, "H. "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 2)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "E. "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 1)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, "B. "))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode("Special Programs without Job Placement Target " + _toDisplayString(info?.trancheInfo?.label), 1)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _hoisted_60,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                                    ?.without_job_place_entity, (data2, inx2) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: inx2,
                                              class: "border border-gray-400 text-center"
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(data2?.sl), 1),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("a", {
                                                  href: `${this.VUE_APP_TMS}/course-summary/1/` +
                                          info?.trancheInfo?.id +
                                          '/' + data2?.id
                                        ,
                                                  target: "_blank",
                                                  class: "text-black fw-bold fs-6 mt-2"
                                                }, _toDisplayString(data2?.entity_short_name), 9, _hoisted_61)
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(Number(data2?.withoutJobtargetTrainee).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data2?.withoutJobenrollment).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data2?.withoutJobfemaleEnrollment).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data2?.withoutJobcertification).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(Number(data2?.withoutjob_placement).toLocaleString()), 1),
                                              _createElementVNode("td", null, _toDisplayString(data2?.without_percentage_of_job_placement
                                          ? (data2?.without_percentage_of_job_placement).toFixed(
                                            2
                                          )
                                          : 0), 1)
                                            ]))
                                          }), 128)),
                                          (
                                    info?.trancheInfo?.id ==
                                    info?.trancheInfo?.parent_tranche_id
                                  )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                                                _createElementVNode("td", _hoisted_63, [
                                                  _createElementVNode("b", null, " Sub-Total Special Programs(" + _toDisplayString(info?.trancheInfo?.label) + ")", 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                                          info?.trancheInfo?.subwithoutjobTotalTrainee
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_65, _toDisplayString(Number(
                                          info?.trancheInfo?.subwithoutjobTotalEnrollment
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_66, _toDisplayString(Number(
                                          info?.trancheInfo?.subwithoutjobTotalfemaleEnrollment
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_67, _toDisplayString(Number(
                                          info?.trancheInfo?.subwithoutjobTotalCertification
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_68, _toDisplayString(Number(
                                          info?.trancheInfo?.subwithoutjobTotalJobPlacement
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_69, _toDisplayString((info?.trancheInfo?.subwithoutjobTotalPercentageOfJobPlacement).toFixed(
                                          2
                                        )), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                                    info?.trancheInfo?.id ==
                                    info?.trancheInfo?.parent_tranche_id
                                  )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                                                _createElementVNode("td", _hoisted_71, [
                                                  _createElementVNode("b", null, [
                                                    _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                                                    (info?.trancheInfo?.id == 2)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, "(D+E) "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 1)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_73, "(A+B) "))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(),
                                                    (info?.trancheInfo?.id == 5)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_74, "(G+H) "))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_75, _toDisplayString(Number(
                                          info?.trancheInfo?.TotalTraineejobBased
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_76, _toDisplayString(Number(
                                          info?.trancheInfo?.TotalEnrollmentjobBased
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_77, _toDisplayString(Number(
                                          info?.trancheInfo?.TotalfemaleEnrollmentjobBased
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_78, _toDisplayString(Number(
                                          info?.trancheInfo?.TotalCertificationjobBased
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_79, _toDisplayString(Number(
                                          info?.trancheInfo?.TotalJobPlacementjobBased
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_80, _toDisplayString((info?.trancheInfo?.TotalPercentageOfJobPlacementjobBased).toFixed(
                                          2
                                        )), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                                    info?.trancheInfo?.id != info?.trancheInfo?.parent_tranche_id
                                  )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                                                _createElementVNode("td", _hoisted_82, [
                                                  _createElementVNode("b", null, [
                                                    _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.parent_tranche?.label) + " ", 1),
                                                    (info?.trancheInfo?.id == 4)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_83, "(D+E+F) "))
                                                      : _createCommentVNode("", true),
                                                    (info?.trancheInfo?.id == 3)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_84, "(A+B+C) "))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_85, _toDisplayString(Number(
                                          info?.trancheInfo?.GrandTotalTrainee
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_86, _toDisplayString(Number(
                                          info?.trancheInfo?.GrandTotalEnrollment
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_87, _toDisplayString(Number(
                                          info?.trancheInfo?.GrandTotalfemaleEnrollment
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_88, _toDisplayString(Number(
                                          info?.trancheInfo?.GrandTotalCertification
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_89, _toDisplayString(Number(
                                          info?.trancheInfo?.GrandTotalJobPlacement
                                        ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_90, _toDisplayString((info?.trancheInfo?.GrandTotalPercentageOfJobPlacement).toFixed(
                                          2
                                        )), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      _createElementVNode("tr", _hoisted_91, [
                                        _hoisted_92,
                                        _createElementVNode("td", _hoisted_93, _toDisplayString(Number(this.FinalTotalTrainee).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_94, _toDisplayString(Number(this.FinalTotalEnrollment).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_95, _toDisplayString(Number(this.FinalTotalfemaleEnrollment).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_96, _toDisplayString(Number(this.FinalTotalCertification).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_97, _toDisplayString(Number(this.FinalTotalJobPlacement).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_98, _toDisplayString(this.FinalTotalPercentageOfJobPlacement.toFixed(2)), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])), [
                            [_directive_loading, _ctx.load]
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}